import { useEvaluationCounts } from "../api/queries/performanceQueries";
import usePermissions from "./usePermissions";

const NO_FILTERS = {};

/**
 * Who sees the performance menus (Performance: view):
 * - canSeeEvaluations: COMPANY scope, or BRANCH scope with evaluations in scope
 *   (the counts endpoint returns 0 for everyone else).
 * - canManageTemplates: COMPANY scope (templates, reports, bulk create).
 */
const usePerformanceAccess = () => {
  const { can, companyWide } = usePermissions();
  const canView = can("performance");
  const wide = companyWide("performance");
  const counts = useEvaluationCounts(NO_FILTERS, { enabled: canView && !wide });
  return {
    canSeeEvaluations: wide || (canView && (counts.data?.total ?? 0) > 0),
    canManageTemplates: wide,
  };
};

export default usePerformanceAccess;
